import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IEskiTalepListesi_View_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IEskiTalepListesi_View_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: string;
  GoBack_dummy: string;
  SelectEskiTalepListesi: any[];
  SelectEskiTalepListesi_dummy: any[];
  wfScreenName: string;
}

export class EskiTalepListesi_View_ScreenBase extends React.PureComponent<IEskiTalepListesi_View_ScreenProps, any> {
  ml = [
    {
      Id: "4f05fda5-b043-9e86-8437-71ea4357a314",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: []
    },
    { Id: "7a8fc238-9831-4128-a954-0cdac59f257a", Name: "en_US", ShortName: "English", LanguagePhrases: [] },
    {
      Id: "2fea6228-284a-4893-804b-fdcc14bf6cfe",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Eski Talep Detay" },
        { Id: 1117500, PropertyName: "value", Value: "UygunlukDurumu" },
        { Id: 3019815, PropertyName: "value", Value: "BaslangicTarihi" },
        { Id: 2477065, PropertyName: "value", Value: "Durum" },
        { Id: 2423830, PropertyName: "value", Value: "FaturaNumarasi" },
        { Id: 5912861, PropertyName: "value", Value: "FaturaTarihi" },
        { Id: 3564474, PropertyName: "value", Value: "FizikiIncelemeyeGittiMi" },
        { Id: 6632060, PropertyName: "value", Value: "FormTarihi" },
        { Id: 5642632, PropertyName: "value", Value: "IletisimTelefonNo" },
        { Id: 1693847, PropertyName: "value", Value: "IncelemeBirimi" },
        { Id: 4056450, PropertyName: "value", Value: "IncelemeBirimi2" },
        { Id: 9575256, PropertyName: "value", Value: "KararZamani" },
        { Id: 2236501, PropertyName: "value", Value: "KargoKodu" },
        { Id: 6598395, PropertyName: "value", Value: "KargoTakipNo" },
        { Id: 8832219, PropertyName: "value", Value: "LostraSalonu" },
        { Id: 2197343, PropertyName: "value", Value: "Magaza" },
        { Id: 3234528, PropertyName: "value", Value: "MagazaAdresi" },
        { Id: 6318402, PropertyName: "value", Value: "MagazaKodu" },
        { Id: 8288855, PropertyName: "value", Value: "MusteriAdSoyad" },
        { Id: 3725289, PropertyName: "value", Value: "MusteriTadilatOnayi" },
        { Id: 4091766, PropertyName: "value", Value: "MusteriTelefonNo" },
        { Id: 4840948, PropertyName: "value", Value: "Sehir" },
        { Id: 4071518, PropertyName: "value", Value: "SorunKullanimKaynaklimi" },
        { Id: 9708794, PropertyName: "value", Value: "SorunUretimKaynaklimi" },
        { Id: 4214208, PropertyName: "value", Value: "TadilatAciklamasi" },
        { Id: 9957896, PropertyName: "value", Value: "TadilatBedeli" },
        { Id: 3315827, PropertyName: "value", Value: "TadilatBirimineUlastimi" },
        { Id: 5374744, PropertyName: "value", Value: "TadilatTamamlandimi" },
        { Id: 7420817, PropertyName: "value", Value: "TalepEdilenislem" },
        { Id: 4234076, PropertyName: "value", Value: "TalepFormuKodu" },
        { Id: 6651369, PropertyName: "value", Value: "TalepKodu" },
        { Id: 7995337, PropertyName: "value", Value: "TalepKonusu" },
        { Id: 6329512, PropertyName: "value", Value: "TalepUrunuKodu" },
        { Id: 1954417, PropertyName: "value", Value: "TalepYapan" },
        { Id: 5754704, PropertyName: "value", Value: "TamamlanmaTarihi" },
        { Id: 4744066, PropertyName: "value", Value: "TarihGunSayisi" },
        { Id: 1087664, PropertyName: "value", Value: "TeslimTarihi" },
        { Id: 1774940, PropertyName: "value", Value: "TeslimTarihigunSayisi" },
        { Id: 9172745, PropertyName: "value", Value: "UcretIadesiYapildimi" },
        { Id: 4562129, PropertyName: "value", Value: "UrunAltKategorisi" },
        { Id: 7306633, PropertyName: "value", Value: "UrunGrubu" },
        { Id: 3294836, PropertyName: "value", Value: "UrunIadesiYapildimi" },
        { Id: 1443156, PropertyName: "value", Value: "UrunKategorisi" },
        { Id: 2384653, PropertyName: "value", Value: "UrunMagazadaVarmiListe" },
        { Id: 6580885, PropertyName: "value", Value: "UrunMagazayaUlastimi" },
        { Id: 1401356, PropertyName: "value", Value: "UrunRengi" },
        { Id: 9788545, PropertyName: "value", Value: "UrunRenkKodu" },
        { Id: 4285304, PropertyName: "value", Value: "UrunSorun" },
        { Id: 2787478, PropertyName: "value", Value: "UrunTanim" },
        { Id: 8987943, PropertyName: "value", Value: "UrunTeslimatYeri" },
        { Id: 6554561, PropertyName: "value", Value: "UrunTeslimEdildimi" },
        { Id: 4935986, PropertyName: "value", Value: "UrunUreticiAdi" },
        { Id: 7916938, PropertyName: "value", Value: "UygunlukAciklamasi" }
      ]
    }
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectEskiTalepListesi: [],
      wfScreenName: ""
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("eskitaleplistesi_view", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.EskiTalepListesi_ViewPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("eskitaleplistesi_view", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("eskitaleplistesi_view", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.EskiTalepListesi_ViewPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  EskiTalepListesi_ViewPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(this.props.screenInputs.Id ?? this.props.screenInputs.id, "Guid")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EskiTalepListesi_View/EskiTalepListesi_ViewPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectEskiTalepListesi = result?.data.selectEskiTalepListesi;
    formVars.eskitaleplistesi_view_5465514_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].uygunlukDurumu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].uygunlukDurumu
        : null
    );
    formVars.eskitaleplistesi_view_5675023_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].baslangicTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].baslangicTarihi
        : null
    );
    formVars.eskitaleplistesi_view_2186068_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].durum
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].durum
        : null
    );
    formVars.eskitaleplistesi_view_1734524_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].faturaNumarasi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].faturaNumarasi
        : null
    );
    formVars.eskitaleplistesi_view_4806646_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].faturaTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].faturaTarihi
        : null
    );
    formVars.eskitaleplistesi_view_1374348_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].fizikiIncelemeyeGittiMi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].fizikiIncelemeyeGittiMi
        : null
    );
    formVars.eskitaleplistesi_view_5224804_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].formTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].formTarihi
        : null
    );
    formVars.eskitaleplistesi_view_6074036_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].iletisimTelefonNo
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].iletisimTelefonNo
        : null
    );
    formVars.eskitaleplistesi_view_8163763_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].incelemeBirimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].incelemeBirimi
        : null
    );
    formVars.eskitaleplistesi_view_1476420_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].incelemeBirimi2
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].incelemeBirimi2
        : null
    );
    formVars.eskitaleplistesi_view_9955245_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].kararZamani
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].kararZamani
        : null
    );
    formVars.eskitaleplistesi_view_7099707_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].kargoKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].kargoKodu
        : null
    );
    formVars.eskitaleplistesi_view_1128032_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].kargoTakipNo
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].kargoTakipNo
        : null
    );
    formVars.eskitaleplistesi_view_9613170_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].lostraSalonu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].lostraSalonu
        : null
    );
    formVars.eskitaleplistesi_view_2646342_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].magaza
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].magaza
        : null
    );
    formVars.eskitaleplistesi_view_2055068_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].magazaAdresi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].magazaAdresi
        : null
    );
    formVars.eskitaleplistesi_view_1709416_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].magazaKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].magazaKodu
        : null
    );
    formVars.eskitaleplistesi_view_9438311_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].musteriAdSoyad
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].musteriAdSoyad
        : null
    );
    formVars.eskitaleplistesi_view_7297905_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].musteriTadilatOnayi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].musteriTadilatOnayi
        : null
    );
    formVars.eskitaleplistesi_view_4665830_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].musteriTelefonNo
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].musteriTelefonNo
        : null
    );
    formVars.eskitaleplistesi_view_2943134_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].sehir
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].sehir
        : null
    );
    formVars.eskitaleplistesi_view_2484959_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].sorunKullanimKaynaklimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].sorunKullanimKaynaklimi
        : null
    );
    formVars.eskitaleplistesi_view_7581499_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].sorunUretimKaynaklimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].sorunUretimKaynaklimi
        : null
    );
    formVars.eskitaleplistesi_view_9230873_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatAciklamasi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatAciklamasi
        : null
    );
    formVars.eskitaleplistesi_view_3886968_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatBedeli
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatBedeli
        : null
    );
    formVars.eskitaleplistesi_view_8431340_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatBirimineUlastimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatBirimineUlastimi
        : null
    );
    formVars.eskitaleplistesi_view_6672693_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatTamamlandimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatTamamlandimi
        : null
    );
    formVars.eskitaleplistesi_view_7924821_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepEdilenislem
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepEdilenislem
        : null
    );
    formVars.eskitaleplistesi_view_3711542_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepFormuKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepFormuKodu
        : null
    );
    formVars.eskitaleplistesi_view_5207319_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepKodu
        : null
    );
    formVars.eskitaleplistesi_view_3030218_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepKonusu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepKonusu
        : null
    );
    formVars.eskitaleplistesi_view_8535779_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepUrunuKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepUrunuKodu
        : null
    );
    formVars.eskitaleplistesi_view_2219732_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepYapan
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepYapan
        : null
    );
    formVars.eskitaleplistesi_view_7459364_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tamamlanmaTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tamamlanmaTarihi
        : null
    );
    formVars.eskitaleplistesi_view_5972330_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tarihGunSayisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tarihGunSayisi
        : null
    );
    formVars.eskitaleplistesi_view_8667013_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].teslimTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].teslimTarihi
        : null
    );
    formVars.eskitaleplistesi_view_2287093_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].teslimTarihigunSayisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].teslimTarihigunSayisi
        : null
    );
    formVars.eskitaleplistesi_view_9161419_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].ucretIadesiYapildimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].ucretIadesiYapildimi
        : null
    );
    formVars.eskitaleplistesi_view_3736009_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunAltKategorisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunAltKategorisi
        : null
    );
    formVars.eskitaleplistesi_view_7864219_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunGrubu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunGrubu
        : null
    );
    formVars.eskitaleplistesi_view_3138728_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunIadesiYapildimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunIadesiYapildimi
        : null
    );
    formVars.eskitaleplistesi_view_1821430_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunKategorisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunKategorisi
        : null
    );
    formVars.eskitaleplistesi_view_3803440_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunMagazadaVarmiListe
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunMagazadaVarmiListe
        : null
    );
    formVars.eskitaleplistesi_view_9668292_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunMagazayaUlastimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunMagazayaUlastimi
        : null
    );
    formVars.eskitaleplistesi_view_9421051_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunRengi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunRengi
        : null
    );
    formVars.eskitaleplistesi_view_9960951_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunRenkKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunRenkKodu
        : null
    );
    formVars.eskitaleplistesi_view_6288489_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunSorun
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunSorun
        : null
    );
    formVars.eskitaleplistesi_view_3350088_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunTanim
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunTanim
        : null
    );
    formVars.eskitaleplistesi_view_9982146_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunTeslimatYeri
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunTeslimatYeri
        : null
    );
    formVars.eskitaleplistesi_view_1272621_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunTeslimEdildimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunTeslimEdildimi
        : null
    );
    formVars.eskitaleplistesi_view_1378269_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunUreticiAdi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunUreticiAdi
        : null
    );
    formVars.eskitaleplistesi_view_2411460_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].uygunlukAciklamasi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].uygunlukAciklamasi
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EskiTalepListesi_ViewPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EskiTalepListesi_ViewPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.eskitaleplistesi_view_5465514_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].uygunlukDurumu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].uygunlukDurumu
        : null
    );

    formVars.eskitaleplistesi_view_5675023_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].baslangicTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].baslangicTarihi
        : null
    );

    formVars.eskitaleplistesi_view_2186068_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].durum
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].durum
        : null
    );

    formVars.eskitaleplistesi_view_1734524_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].faturaNumarasi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].faturaNumarasi
        : null
    );

    formVars.eskitaleplistesi_view_4806646_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].faturaTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].faturaTarihi
        : null
    );

    formVars.eskitaleplistesi_view_1374348_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].fizikiIncelemeyeGittiMi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].fizikiIncelemeyeGittiMi
        : null
    );

    formVars.eskitaleplistesi_view_5224804_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].formTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].formTarihi
        : null
    );

    formVars.eskitaleplistesi_view_6074036_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].iletisimTelefonNo
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].iletisimTelefonNo
        : null
    );

    formVars.eskitaleplistesi_view_8163763_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].incelemeBirimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].incelemeBirimi
        : null
    );

    formVars.eskitaleplistesi_view_1476420_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].incelemeBirimi2
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].incelemeBirimi2
        : null
    );

    formVars.eskitaleplistesi_view_9955245_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].kararZamani
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].kararZamani
        : null
    );

    formVars.eskitaleplistesi_view_7099707_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].kargoKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].kargoKodu
        : null
    );

    formVars.eskitaleplistesi_view_1128032_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].kargoTakipNo
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].kargoTakipNo
        : null
    );

    formVars.eskitaleplistesi_view_9613170_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].lostraSalonu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].lostraSalonu
        : null
    );

    formVars.eskitaleplistesi_view_2646342_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].magaza
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].magaza
        : null
    );

    formVars.eskitaleplistesi_view_2055068_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].magazaAdresi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].magazaAdresi
        : null
    );

    formVars.eskitaleplistesi_view_1709416_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].magazaKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].magazaKodu
        : null
    );

    formVars.eskitaleplistesi_view_9438311_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].musteriAdSoyad
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].musteriAdSoyad
        : null
    );

    formVars.eskitaleplistesi_view_7297905_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].musteriTadilatOnayi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].musteriTadilatOnayi
        : null
    );

    formVars.eskitaleplistesi_view_4665830_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].musteriTelefonNo
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].musteriTelefonNo
        : null
    );

    formVars.eskitaleplistesi_view_2943134_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].sehir
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].sehir
        : null
    );

    formVars.eskitaleplistesi_view_2484959_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].sorunKullanimKaynaklimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].sorunKullanimKaynaklimi
        : null
    );

    formVars.eskitaleplistesi_view_7581499_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].sorunUretimKaynaklimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].sorunUretimKaynaklimi
        : null
    );

    formVars.eskitaleplistesi_view_9230873_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatAciklamasi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatAciklamasi
        : null
    );

    formVars.eskitaleplistesi_view_3886968_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatBedeli
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatBedeli
        : null
    );

    formVars.eskitaleplistesi_view_8431340_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatBirimineUlastimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatBirimineUlastimi
        : null
    );

    formVars.eskitaleplistesi_view_6672693_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tadilatTamamlandimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tadilatTamamlandimi
        : null
    );

    formVars.eskitaleplistesi_view_7924821_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepEdilenislem
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepEdilenislem
        : null
    );

    formVars.eskitaleplistesi_view_3711542_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepFormuKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepFormuKodu
        : null
    );

    formVars.eskitaleplistesi_view_5207319_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepKodu
        : null
    );

    formVars.eskitaleplistesi_view_3030218_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepKonusu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepKonusu
        : null
    );

    formVars.eskitaleplistesi_view_8535779_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepUrunuKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepUrunuKodu
        : null
    );

    formVars.eskitaleplistesi_view_2219732_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].talepYapan
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].talepYapan
        : null
    );

    formVars.eskitaleplistesi_view_7459364_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tamamlanmaTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tamamlanmaTarihi
        : null
    );

    formVars.eskitaleplistesi_view_5972330_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].tarihGunSayisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].tarihGunSayisi
        : null
    );

    formVars.eskitaleplistesi_view_8667013_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].teslimTarihi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].teslimTarihi
        : null
    );

    formVars.eskitaleplistesi_view_2287093_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].teslimTarihigunSayisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].teslimTarihigunSayisi
        : null
    );

    formVars.eskitaleplistesi_view_9161419_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].ucretIadesiYapildimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].ucretIadesiYapildimi
        : null
    );

    formVars.eskitaleplistesi_view_3736009_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunAltKategorisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunAltKategorisi
        : null
    );

    formVars.eskitaleplistesi_view_7864219_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunGrubu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunGrubu
        : null
    );

    formVars.eskitaleplistesi_view_3138728_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunIadesiYapildimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunIadesiYapildimi
        : null
    );

    formVars.eskitaleplistesi_view_1821430_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunKategorisi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunKategorisi
        : null
    );

    formVars.eskitaleplistesi_view_3803440_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunMagazadaVarmiListe
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunMagazadaVarmiListe
        : null
    );

    formVars.eskitaleplistesi_view_9668292_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunMagazayaUlastimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunMagazayaUlastimi
        : null
    );

    formVars.eskitaleplistesi_view_9421051_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunRengi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunRengi
        : null
    );

    formVars.eskitaleplistesi_view_9960951_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunRenkKodu
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunRenkKodu
        : null
    );

    formVars.eskitaleplistesi_view_6288489_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunSorun
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunSorun
        : null
    );

    formVars.eskitaleplistesi_view_3350088_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunTanim
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunTanim
        : null
    );

    formVars.eskitaleplistesi_view_9982146_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunTeslimatYeri
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunTeslimatYeri
        : null
    );

    formVars.eskitaleplistesi_view_1272621_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunTeslimEdildimi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunTeslimEdildimi
        : null
    );

    formVars.eskitaleplistesi_view_1378269_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].urunUreticiAdi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].urunUreticiAdi
        : null
    );

    formVars.eskitaleplistesi_view_2411460_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectEskiTalepListesi !== undefined
        ? stateVars.SelectEskiTalepListesi?.length > 0
          ? stateVars.SelectEskiTalepListesi[0].uygunlukAciklamasi
          : null
        : this.state.SelectEskiTalepListesi?.length > 0
        ? this.state.SelectEskiTalepListesi[0].uygunlukAciklamasi
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EskiTalepListesi_ViewComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }

  getWfPageComponent = () => {
    return ReactSystemFunctions.getWfPageComponent(this, this.state.wfScreenName);
  };
}
